import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { User } from '@/types'

// Authentication relies exclusively on httpOnly cookies set by the backend:
// no token is ever stored in localStorage (XSS hardening). The persisted
// isAuthenticated flag only tells the app to attempt /auth/me on load.
interface AuthState {
  user: User | null
  isAuthenticated: boolean
  // null = segue la preferenza di sistema (prefers-color-scheme);
  // diventa booleano esplicito alla prima commutazione manuale
  isDarkMode: boolean | null
  language: 'it' | 'en'

  setUser: (user: User | null) => void
  logout: () => void
  toggleDarkMode: () => void
  setLanguage: (lang: 'it' | 'en') => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      isAuthenticated: false,
      isDarkMode: null,
      language: 'it',

      setUser: (user) =>
        set({ user, isAuthenticated: !!user }),

      logout: () => {
        set({ user: null, isAuthenticated: false })
      },

      toggleDarkMode: () =>
        set(() => {
          // The DOM class is the effective source of truth (covers the
          // "system preference" case where isDarkMode is still null)
          const next = !document.documentElement.classList.contains('dark')
          document.documentElement.classList.toggle('dark', next)
          return { isDarkMode: next }
        }),

      setLanguage: (language) => set({ language }),
    }),
    {
      name: 'varia-auth',
      partialize: (state) => ({
        isAuthenticated: state.isAuthenticated,
        isDarkMode: state.isDarkMode,
        language: state.language,
      }),
    }
  )
)
